import type { FunctionComponent } from 'react';
import { paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { DialogModal } from '../../../../../../../app-kit/components/DialogModal/DialogModal';
import { OutboundLink } from '../../../../../../../app-kit/components/OutboundLink/OutboundLink';

interface SchoolCatchmentDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

const StyledOutboundLink = styled(OutboundLink)`
  color: ${paletteHelper('textSecondary')};
  &:hover {
    color: ${paletteHelper('textSecondary')};
  }
`;

const CreativeCommonsLinkV3: FunctionComponent = () => {
  return (
    <StyledOutboundLink
      href="https://creativecommons.org/licenses/by/3.0/"
      outboundLinkType="creative-commons-outbound-link"
      variant="inline"
      rel="noopener noreferrer"
    >
      CC BY 3.0
    </StyledOutboundLink>
  );
};

const CreativeCommonsLinkV4: FunctionComponent = () => {
  return (
    <StyledOutboundLink
      href="https://creativecommons.org/licenses/by/4.0/"
      outboundLinkType="creative-commons-outbound-link"
      variant="inline"
      rel="noopener noreferrer"
    >
      CC BY 4.0
    </StyledOutboundLink>
  );
};

export const SchoolCatchmentDisclaimer: FunctionComponent<SchoolCatchmentDisclaimerProps> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="School data"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
    >
      <BodyText>
        Always check with the school to confirm the actual boundaries of the catchment zone. REA
        makes no representations or warranties regarding the accuracy of this data.
      </BodyText>
      <BodyText>
        &copy; State Government of Victoria. Licensed under the Creative Commons Attribution
        International (
        <CreativeCommonsLinkV4 />) Licence.
      </BodyText>
      <BodyText>
        &copy; State of NSW (Data.NSW). Licensed under the Creative Commons Attribution
        International (
        <CreativeCommonsLinkV4 />) Licence.
      </BodyText>
      <BodyText>
        &copy; Queensland Government. Licensed under the Creative Commons Attribution International
        (
        <CreativeCommonsLinkV4 />) License.
      </BodyText>
      <BodyText>
        &copy; South Australian Government. Licensed under the Creative Commons Attribution
        International (
        <CreativeCommonsLinkV4 />) License.
      </BodyText>
      <BodyText>
        &copy; Australian Capital Territory. Licensed under the Creative Commons Attribution
        International (
        <CreativeCommonsLinkV4 />) License.
      </BodyText>
      <BodyText>
        &copy; Tasmanian Government. Licensed under the Creative Commons Attribution International (
        <CreativeCommonsLinkV3 />) License.
      </BodyText>
      <BodyText>
        &copy; Department of Education, Western Australia. Licensed under the Creative Commons
        Attribution International (
        <CreativeCommonsLinkV4 />) License.
      </BodyText>
      <BodyText>
        &copy; Northern Territory of Australia (Department of Education) 2017. Licensed under the
        Creative Commons Attribution International (
        <CreativeCommonsLinkV4 />) License.
      </BodyText>
    </DialogModal>
  );
};
